import React from "react";
import { Link } from "react-router-dom";
import "./careers-footer.scss";

const YEAR = new Date().getFullYear();

export default function CareersFooter() {
  return (
    <footer className="careers-footer">
      <div className="careers-footer__accent" aria-hidden="true" />
      <div className="careers-footer__inner">
        <div className="careers-footer__brand-block">
          <Link to="/" className="careers-footer__brand">
            QikTruck <span>Careers</span>
          </Link>
          <p className="careers-footer__lede">
            Training programs and paid Creator scripts for logistics talent in South Africa.
          </p>
          <div className="careers-footer__cta-row">
            <Link to="/academy" className="careers-footer__cta careers-footer__cta--primary">
              Browse programs
            </Link>
            <Link to="/creator" className="careers-footer__cta careers-footer__cta--ghost">
              Creator Program
            </Link>
          </div>
        </div>

        <nav className="careers-footer__nav" aria-label="Careers footer">
          <div className="careers-footer__col">
            <p className="careers-footer__heading">Learn</p>
            <ul>
              <li>
                <Link to="/academy">Training programs</Link>
              </li>
              <li>
                <Link to="/me">My progress</Link>
              </li>
              <li>
                <Link to="/me/certificates">Certificates</Link>
              </li>
            </ul>
          </div>

          <div className="careers-footer__col">
            <p className="careers-footer__heading">Create</p>
            <ul>
              <li>
                <Link to="/creator">How it works</Link>
              </li>
              <li>
                <Link to="/me/creator">Creator Scripts</Link>
              </li>
              <li>
                <Link to="/me/creator/payments">Payments</Link>
              </li>
              <li>
                <Link to="/creator/license">Content License</Link>
              </li>
              <li>
                <Link to="/creator/privacy">Creator privacy</Link>
              </li>
            </ul>
          </div>

          <div className="careers-footer__col">
            <p className="careers-footer__heading">Account</p>
            <ul>
              <li>
                <Link to="/login">Sign in</Link>
              </li>
              <li>
                <Link to="/me/profile">Profile</Link>
              </li>
              <li>
                <a href="mailto:support@qiktruck.co.za">Email support</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>

      <div className="careers-footer__bottom">
        <p className="careers-footer__copy">© {YEAR} QikTruck. Johannesburg, South Africa.</p>
        <div className="careers-footer__bottom-links">
          <a href="https://qiktruck.co.za" target="_blank" rel="noopener noreferrer">
            qiktruck.co.za
          </a>
          <a href="mailto:support@qiktruck.co.za">support@qiktruck.co.za</a>
        </div>
      </div>
    </footer>
  );
}
